import * as Ajv from 'ajv';
import { DataValidationCxt, AnySchemaObject } from 'ajv/dist/types';
import { PlatformSpecService } from '@warehouse/global-entities/core';

export const alidValidator: Ajv.KeywordDefinition = {
	keyword: 'alidValidForPlatformSpec',
	type: 'string',
	schemaType: 'string',
	validate: (configValue: string, alidValue: string, _?: AnySchemaObject, contextData?: DataValidationCxt) => {
		if (!contextData) return false;
		const platformSpecValue = contextData.rootData[configValue as keyof typeof contextData.rootData];
		if (!platformSpecValue) return false;
		return PlatformSpecService.isAlidValidForPlatformSpec({ alid: alidValue, platformSpecId: platformSpecValue });
	},
};

// @ts-ignore
const schema: Ajv.JSONSchemaType<any> = {
	type: 'object',
	properties: {
		// Step 1
		titleType: {
			type: 'string',
			minLength: 1,
			errorMessage: { minLength: 'The title type is required' },
		},
		title: {
			type: 'string',
			minLength: 1,
			errorMessage: { minLength: 'The title is required' },
		},
		workTypeDetail: {
			type: 'string',
			minLength: 1,
			errorMessage: { minLength: 'This field is required' },
		},
		licensor: {
			type: 'string',
			minLength: 1,
			errorMessage: { minLength: 'The licensor is required' },
		},
		relationshipType: {
			type: 'string',
			minLength: 1,
			errorMessage: { minLength: 'The type is required' },
		},
		houseSequence: {
			type: 'string',
			minLength: 1,
			errorMessage: { minLength: 'The house sequence is required' },
		},
		titleLanguage: {
			type: 'string',
			minLength: 1,
			errorMessage: { minLength: 'The title language is required' },
		},
		parentTitle: {
			type: 'object',
			properties: {
				parentType: { type: 'string' },
				title: {
					type: 'object',
					required: ['uuid'],
					errorMessage: { required: { uuid: 'The parent is required.' } },
					properties: {
						uuid: {
							type: 'string',
						},
					},
				},
			},
			required: ['title'],
		},

		// Step 2
		countriesOfOrigin: {
			type: 'array',
			items: { type: 'string' },
			minItems: 1,
			errorMessage: {
				minItems: 'At least one country of origin is required',
			},
		},
		releaseDate: { type: 'object' },
		approximateLength: {
			type: 'number',
			minimum: 0,
			errorMessage: { minimum: 'The approximate length should be a positive number.' },
		},
		distributionNumber: {
			type: 'string',
			minLength: 1,
			errorMessage: { minLength: 'The distribution number is required' },
		},
		sequenceNumber: {
			type: 'string',
			minLength: 1,
			errorMessage: { minLength: 'The sequence number is required' },
		},
		sortTitle: {
			type: 'string',
			minLength: 1,
			errorMessage: { minLength: 'The sort title is required' },
		},
		originalLanguages: {
			type: 'array',
			items: {
				type: 'object',
				properties: {
					mode: {
						type: 'string',
						minLength: 1,
						errorMessage: {
							minLength: 'The mode is required',
						},
					},
					language: {
						type: 'string',
						minLength: 1,
						errorMessage: {
							minLength: 'The language is required',
						},
					},
					default: {
						type: 'boolean',
					},
				},
			},
			minItems: 1,
			errorMessage: {
				minItems: 'At least one original language is required',
			},
		},
		versionLanguages: {
			type: 'array',
			items: {
				type: 'string',
			},
			minItems: 1,
			errorMessage: {
				minItems: 'At least one version language is required',
			},
		},
		// versionLanguages: {
		// 	type: 'array',
		// 	items: {
		// 		type: 'object',
		// 		properties: {
		// 			mode: {
		// 				type: 'string',
		// 				minLength: 1,
		// 				errorMessage: {
		// 					minLength: 'The mode is required',
		// 				},
		// 			},
		// 			langTermUID: {
		// 				type: 'string',
		// 				minLength: 1,
		// 				errorMessage: {
		// 					minLength: 'The language is required',
		// 				},
		// 			},
		// 		},
		// 	},
		// 	minItems: 1,
		// 	errorMessage: {
		// 		minItems: 'At least one version language is required',
		// 	},
		// Performance
		madeForRegions: {
			type: 'object',
			properties: {
				madeForRegions: {
					type: 'array',
					items: { type: 'string' },
					minItems: 1,
					errorMessage: { minItems: 'The made for regions is required' },
				},
				isInclude: {
					type: 'boolean',
					default: true,
				},
			},
			errorMessage: { minLength: 'The made for region is required' },
		},
		editDescription: {
			type: 'string',
		},
		colorType: {
			type: 'string',
			minLength: 1,
			errorMessage: { minLength: 'The color type is required' },
		},
		createDefaultEdit: {
			type: 'boolean',
		},
		platformSpecification: {
			type: 'string',
			minLength: 1,
			errorMessage: { minLength: 'The Platform Specification is required' },
		},
		alid: {
			type: 'string',
			minLength: 1,
			alidValidForPlatformSpec: 'platformSpecification',
			errorMessage: {
				minLength: 'The ALID is required',
				alidValidForPlatformSpec: 'The ALID must be valid for the platform specification',
			},
		},
	},
	required: [
		'titleType',
		'structuralType',
		'title',
		'titleLanguage',
		'parentTitle',
		'countriesOfOrigin',
		'mode',
		'releaseDate',
		'sortTitle',
		'houseSequence',
		'distributionNumber',
		'sequenceNumber',
		'licensor',
		'originalLanguages',
		'versionLanguages',
		'madeForRegions',
		'workTypeDetail',
		'relationshipType',
		'platformSpecification',
		'alid',
	],
	additionalProperties: false,
};

export default schema;
